import '@sorpetaler/ui/src/styles/global.less';
import './src/utils/fragments';
export { wrapRootElement } from './src/wrap-with-metrica-provider';

export const onClientEntry = () => {
  console.log(`sorpetaler-website v${process.env.GATSBY_APP_VERSION}`);
};

export const onRouteUpdate = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('sorpetaler:route-update'));
  }
};
